import { NavLink } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar() {
  return (
    <aside className="sidebar">
      <nav>
        <NavLink to="/dashboard">Dashboard</NavLink>
        <NavLink to="/orders">Orders</NavLink>
        <NavLink to="/products">Products</NavLink>
        <NavLink to="/rfqs">RFQs</NavLink>
        <NavLink to="/customers">Customers</NavLink>
        <NavLink to="/login">Logout</NavLink>
      </nav>
    </aside>
  );
}
